export default __webpack_public_path__ + "static/media/calendar.f5273630.svg";